'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.deck.gce.serverGroup.configure.advancedCapacitySelector.component', [])
  .component('gceServerGroupAdvancedCapacitySelector', {
    bindings: {
      command: '='
    },
    templateUrl: require('./advancedCapacitySelector.component.html')
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/google/src/serverGroup/configure/wizard/capacity/advancedCapacitySelector.component.js